import './Legal.css';

export default function PrivacyPolicy() {
  return (
    <main className="legal">
      <section className="legal__hero">
        <div className="container">
          <p className="label">⚛ Legal</p>
          <h1 className="legal__heading">Privacy Policy</h1>
          <p className="legal__meta">Last updated: January 2024</p>
        </div>
      </section>

      <section className="legal__content">
        <div className="container legal__body">

          <div className="legal__section">
            <h2>1. Introduction</h2>
            <p>
              The Nuclear Society of Kenya ("NSK", "we", "us", or "our") is committed
              to protecting your personal information. This Privacy Policy explains how
              we collect, use, and safeguard information when you visit our website or
              become a member of NSK.
            </p>
          </div>

          <div className="legal__section">
            <h2>2. Information We Collect</h2>
            <p>We may collect the following types of information:</p>
            <ul>
              <li><strong>Personal details</strong> — name, email address, phone number, and professional qualifications when you apply for membership or contact us.</li>
              <li><strong>Usage data</strong> — pages visited, time spent on the site, and browser type, collected automatically via cookies.</li>
              <li><strong>Communications</strong> — emails or messages you send to NSK.</li>
            </ul>
          </div>

          <div className="legal__section">
            <h2>3. How We Use Your Information</h2>
            <p>We use your information to:</p>
            <ul>
              <li>Process and manage your NSK membership</li>
              <li>Send you our newsletter, event notices, and updates (with your consent)</li>
              <li>Respond to your enquiries and support requests</li>
              <li>Improve our website and services</li>
              <li>Comply with legal obligations</li>
            </ul>
          </div>

          <div className="legal__section">
            <h2>4. Sharing Your Information</h2>
            <p>
              NSK does not sell, trade, or rent your personal information to third
              parties. We may share information with trusted service providers who
              assist us in operating our website and conducting our activities,
              provided they agree to keep your information confidential.
            </p>
          </div>

          <div className="legal__section">
            <h2>5. Data Retention</h2>
            <p>
              We retain your personal information for as long as your membership is
              active or as needed to provide services. You may request deletion of
              your data at any time by contacting us at{' '}
              <a href="mailto:info@nuclearsocietyofkenya.org">
                info@nuclearsocietyofkenya.org
              </a>.
            </p>
          </div>

          <div className="legal__section">
            <h2>6. Cookies</h2>
            <p>
              Our website uses cookies to enhance your browsing experience. You may
              disable cookies through your browser settings, though some features of
              the site may not function correctly as a result.
            </p>
          </div>

          <div className="legal__section">
            <h2>7. Your Rights</h2>
            <p>You have the right to:</p>
            <ul>
              <li>Access the personal data we hold about you</li>
              <li>Request correction of inaccurate data</li>
              <li>Request deletion of your data</li>
              <li>Withdraw consent to marketing communications at any time</li>
            </ul>
          </div>

          <div className="legal__section">
            <h2>8. Contact Us</h2>
            <p>
              If you have any questions about this Privacy Policy, please contact
              us at{' '}
              <a href="mailto:info@nuclearsocietyofkenya.org">
                info@nuclearsocietyofkenya.org
              </a>.
            </p>
          </div>

        </div>
      </section>
    </main>
  );
}